
import { Fancybox } from "@fancyapps/ui";
Fancybox.bind("[data-fancybox]", {
    // Your custom options
});

var techLayerSelect = document.getElementById('techLayerSelect') as HTMLSelectElement;
if (techLayerSelect) {
    techLayerSelect.addEventListener('change', function () {
        var selectedTechLayerId = this.value;
        // G�r n�got med det valda ID:t
        window.location.href = location.href.replace(location.search, '') + "?TechTypeId=" + selectedTechLayerId;
    });
}

var hamburgerMenu = document.getElementById('hamburger-menu') as HTMLButtonElement;
var navigation = document.getElementById('navigation') as HTMLElement;

if (hamburgerMenu) {
    hamburgerMenu.addEventListener('click', function () {
        hamburgerMenu.classList.toggle("open")
        navigation.classList.toggle("mobile-open")
    });
}

// Retrieve all buttons with .btn-prevPage class and add browser navigate back click functionality
const prevPageButtons = document.querySelectorAll(".btn-prevPage") as NodeListOf<HTMLButtonElement>;
if (prevPageButtons != null && prevPageButtons?.length > 0) {
    Array.from(prevPageButtons).forEach(button => {
        button.addEventListener("click", () => {
            window.history.back();
        })
    })
}
